import h from "../../@babel/runtime/helpers/esm/extends2.mjs";
import v from "../../@babel/runtime/helpers/esm/defineProperty2.mjs";
import f from "../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import * as r from "react";
import u from "../../rc-resize-observer/es/index.mjs";
import x from "../../classnames/index2.mjs";
var g = /* @__PURE__ */ r.forwardRef(function(e, l) {
  var m = e.height, o = e.offset, s = e.children, i = e.prefixCls, n = e.onInnerResize, p = e.innerProps, a = {}, t = {
    display: "flex",
    flexDirection: "column"
  };
  return o !== void 0 && (a = {
    height: m,
    position: "relative",
    overflow: "hidden"
  }, t = f(f({}, t), {}, {
    transform: "translateY(".concat(o, "px)"),
    position: "absolute",
    left: 0,
    right: 0,
    top: 0
  })), /* @__PURE__ */ r.createElement("div", {
    style: a
  }, /* @__PURE__ */ r.createElement(u, {
    onResize: function(c) {
      var d = c.offsetHeight;
      d && n && n();
    }
  }, /* @__PURE__ */ r.createElement("div", h({
    style: t,
    className: x(v({}, "".concat(i, "-holder-inner"), i)),
    ref: l
  }, p), s)));
});
g.displayName = "Filler";
export {
  g as default
};
//# sourceMappingURL=Filler.mjs.map
